module.exports = __webpack_public_path__ + "assets/img/28_975.318d3ef2.jpg";